export default __webpack_public_path__ + "media/packs/images/icons/buoy-1e9c41a3afa836bee4f30d4590039a27.svg";